export default "__VITE_ASSET__DI0beBJx__"